import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
// pages

import User from './pages/User';
import ProfilePage from './pages/Profile';
import IndividualUser from './pages/IndivualUser';
import IndustryUser from './pages/IndustryUser';
import LifeMemberUser from './pages/LifeMemberUser';
import SeniorCitizenUser from './pages/SeniorCitizenUser';
import TradeUnionUser from './pages/TradeUnionUser';
import AssociationUser from './pages/AssociationUser';
import InstitutionUser from './pages/InstitutionUser';
import StudentUser from './pages/StudentUser';
import Payment from './pages/Payment';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Calendar from './pages/Calendar';
import CompanySelector from './pages/Company';
import DashboardApp from './pages/DashboardApp';
import Email from './pages/Email';

// ----------------------------------------------------------------------

export default function Router() {
  const isAuthenticated = !!localStorage.getItem('token'); // Check if user is authenticated

  const handleDateChange = (date) => {
    console.log('Selected date:', date);
  }

  return useRoutes([
    {
      path: '/dashboard',
      
      element: isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'user', element: <User /> },
        {path: 'indivualuser', element: <IndividualUser />},
        {path: 'industryuser', element: <IndustryUser />},
        {path: 'lifememberuser', element: <LifeMemberUser />},
        {path: 'seniorcitizenuser', element: <SeniorCitizenUser />},
        {path: 'studentuser', element: <StudentUser />},
        {path: 'tradeunionuser', element: <TradeUnionUser />},
        {path: 'associationuser', element: <AssociationUser />},
        {path: 'institutionuser', element: <InstitutionUser />},
        { path: 'calendar', element: <Calendar onDateChange={handleDateChange} /> },
        {path: 'payment', element: <Payment/>},
        {path: 'company', element: <CompanySelector/>},
        {path:'profile',element:<ProfilePage/>},
        {path:'email',element:<Email/>}
       
      ],
    },
    {
      path: '/login',
      element: !isAuthenticated ? <Login /> : <Navigate to="/dashboard/app" />,
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/login" /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
}
